var map = {
	"./1(2).jpg": 41874,
	"./1(3).jpg": 94243,
	"./1(4).jpg": 99675,
	"./1(5).jpg": 79852,
	"./1(6).jpg": 3747,
	"./1.jpg": 46609,
	"./10.jpg": 34038,
	"./11.jpg": 16381,
	"./12.jpg": 83418,
	"./13.jpg": 60918,
	"./14.jpg": 4689,
	"./15.jpg": 21971,
	"./16.jpg": 33431,
	"./18.jpg": 32357,
	"./19.jpg": 22229,
	"./2.jpg": 10503,
	"./20.jpg": 50163,
	"./21.jpg": 21723,
	"./24.jpg": 80995,
	"./3.jpg": 55657,
	"./4.jpg": 21086,
	"./5.jpg": 48071,
	"./6.jpg": 28240,
	"./7.jpg": 25216,
	"./8.jpg": 36311,
	"./9.jpg": 33079,
	"./AllStudent.jpg": 17810,
	"./DSC_3497.JPG": 59372,
	"./DSC_3502.JPG": 75012,
	"./DSC_8178.jpg": 96703,
	"./photogallery1.jpg": 18827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95138;